import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d883e1a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-base font-bold" }, "Items", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "mr-3"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-dollar-sign" }, " ", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Calc Basecost ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chart-pie" }, " ", -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Calc Profit ")
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-shipping-fast" }, null, -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode("  Update Tracking ")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-dolly-flatbed" }, null, -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode("  Update Delivery ")
const _hoisted_13 = { class: "order-item-artwork w-full 2xl:w-5/12" }
const _hoisted_14 = { class: "border thumbnail-wrapper" }
const _hoisted_15 = { class: "w-full 2xl:w-5/12 mt-3 2xl:mt-0 2xl:p-3 border-b border-r-0 2xl:border-r 2xl:border-b-0" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 1,
  class: "font-bold"
}
const _hoisted_18 = { style: {"font-size":"0.75rem"} }
const _hoisted_19 = { class: "mt-2" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Variant: ", -1))
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xs" }, "Save", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xs" }, "Cancel", -1))
const _hoisted_25 = { key: 1 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" })
], -1))
const _hoisted_27 = { key: 1 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "SKU:", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, /*#__PURE__*/_toDisplayString(`FFM code: `), -1))
const _hoisted_30 = { key: 0 }
const _hoisted_31 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_32 = {
  key: 0,
  class: "ml-2"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = {
  key: 1,
  class: "custom-text-mini"
}
const _hoisted_36 = { class: "mt-2" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Quantity:", -1))
const _hoisted_39 = { key: 1 }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Refund Qty:", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Design Qty:", -1))
const _hoisted_42 = { class: "mt-2" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, /*#__PURE__*/_toDisplayString('Custom: '), -1))
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = {
  key: 0,
  span: 24,
  class: "flex mt-2"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "w-24" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Custom Texts:")
], -1))
const _hoisted_49 = { class: "ml-0" }
const _hoisted_50 = {
  key: 0,
  class: "w-full 2xl:w-1/6 flex items-center justify-center mt-6 2xl:mt-0"
}
const _hoisted_51 = {
  key: 0,
  class: "text-base font-bold text-right"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-between card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold" }, "Timeline")
], -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Change history")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TitleInfo = _resolveComponent("TitleInfo")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_slot_error = _resolveComponent("slot-error")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_UploadImage = _resolveComponent("UploadImage")!
  const _component_UploadDesign = _resolveComponent("UploadDesign")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_DetailOrderItem = _resolveComponent("DetailOrderItem")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_OrderFeesCard = _resolveComponent("OrderFeesCard")!
  const _component_OrderProfitCard = _resolveComponent("OrderProfitCard")!
  const _component_Timeline = _resolveComponent("Timeline")!
  const _component_ChangeHistoryContent = _resolveComponent("ChangeHistoryContent")!
  const _component_OrderInfo = _resolveComponent("OrderInfo")!
  const _component_UpdateTrackingDialog = _resolveComponent("UpdateTrackingDialog")!
  const _component_UpdateDeliveryDialog = _resolveComponent("UpdateDeliveryDialog")!
  const _component_CustomDialog = _resolveComponent("CustomDialog")!
  const _component_ChangeCatalogCodeDialog = _resolveComponent("ChangeCatalogCodeDialog")!
  const _component_section_layout_content = _resolveComponent("section-layout-content")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_section_layout_content, _mergeProps(_ctx.content, {
    backPageTitle: `Back`,
    style: {"overflow":"hidden"}
  }), {
    default: _withCtx(() => [
      _withDirectives(_createVNode(_component_el_row, { gutter: 24 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { gutter: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_TitleInfo, {
                state: _ctx.state,
                userInfo: _ctx.userInfo,
                onRefresh: _ctx.fetchRecord,
                isShowActions: _ctx.isEditable
              }, null, 8, ["state", "userInfo", "onRefresh", "isShowActions"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 18 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, null, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _hoisted_2,
                    (_ctx.isEditable)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          (
                    _ctx.state.order.status === _ctx.ORDER_STATUS.IN_REVIEW ||
                    _ctx.state.order.status === _ctx.ORDER_STATUS.APPROVED ||
                    _ctx.state.order.status === _ctx.ORDER_STATUS.IN_PRODUCTION ||
                    _ctx.state.order.status === _ctx.ORDER_STATUS.IN_TRANSIT ||
                    _ctx.state.order.status === _ctx.ORDER_STATUS.FULFILLED ||
                    _ctx.state.order.status === _ctx.ORDER_STATUS.PARTIALLY_FULFILLED
                  )
                            ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                                _createVNode(_component_el_button, {
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.reCalculateOrderBaseCost())),
                                  loading: _ctx.calculatingOrderBasecost,
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_5,
                                    _hoisted_6
                                  ]),
                                  _: 1
                                }, 8, ["loading"]),
                                (_ctx.state.order.status !== _ctx.ORDER_STATUS.IN_REVIEW)
                                  ? (_openBlock(), _createBlock(_component_el_button, {
                                      key: 0,
                                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.reCalculateOrderProfit())),
                                      loading: _ctx.calculatingOrderProfit,
                                      size: "small"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_7,
                                        _hoisted_8
                                      ]),
                                      _: 1
                                    }, 8, ["loading"]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (
                    _ctx.state.order.status === _ctx.ORDER_STATUS.IN_PRODUCTION ||
                    _ctx.state.order.status === _ctx.ORDER_STATUS.IN_TRANSIT
                  )
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 1,
                                size: "small",
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showModalUpdateTracking()))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_9,
                                  _hoisted_10
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (
                    _ctx.state.order.status === _ctx.ORDER_STATUS.IN_PRODUCTION ||
                    _ctx.state.order.status === _ctx.ORDER_STATUS.IN_TRANSIT ||
                    _ctx.state.order.status === _ctx.ORDER_STATUS.FULFILLED ||
                    _ctx.state.order.status === _ctx.ORDER_STATUS.PARTIALLY_FULFILLED
                  )
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 2,
                                size: "small",
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showModalUpdateDelivery()))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_11,
                                  _hoisted_12
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.order.items.filter(
              (i) => i.sku !== 'Tip'
            ), (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_row, {
                      key: item.sku
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_el_image, {
                              "preview-src-list": [_ctx.imageUrl(item.imageSrc)],
                              src: _ctx.imageUrl(item.imageSrc, true, 400),
                              class: "w-full",
                              title: "Click to preview"
                            }, {
                              error: _withCtx(() => [
                                _createVNode(_component_slot_error, {
                                  urlError: item.imageSrc
                                }, null, 8, ["urlError"])
                              ]),
                              _: 2
                            }, 1032, ["preview-src-list", "src"])
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ARTWORK_SPACES, (artwork) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "order-artwork h-full",
                              key: artwork
                            }, [
                              (item[artwork] && !_ctx.data.isLoading)
                                ? (_openBlock(), _createBlock(_component_UploadImage, {
                                    key: 0,
                                    setData: item,
                                    itemIndex: index,
                                    data: item[artwork],
                                    artwork: artwork,
                                    onChangeArtwork: _ctx.changeArtwork,
                                    class: "border order-artwork-upload",
                                    permission: 
                    _ctx.validateEditArtworkCheck(_ctx.state.order.status)
                      ? 'all'
                      : 'read'
                  
                                  }, null, 8, ["setData", "itemIndex", "data", "artwork", "onChangeArtwork", "permission"]))
                                : (_openBlock(), _createBlock(_component_UploadDesign, {
                                    key: 1,
                                    onUploaded: _ctx.uploaded,
                                    artworkName: artwork,
                                    itemIndex: index,
                                    disableEdit: !_ctx.validateEditArtworkCheck(_ctx.state.order.status),
                                    class: "order-artwork-upload"
                                  }, null, 8, ["onUploaded", "artworkName", "itemIndex", "disableEdit"]))
                            ]))
                          }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          (item.productId)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                                _createVNode(_component_router_link, {
                                  to: {
                    name: 's.product-detail',
                    params: { id: item.productId },
                  },
                                  class: "font-bold text-blue-600"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.itemName), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["to"])
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(item.itemName), 1)),
                          (item.refundStatus)
                            ? (_openBlock(), _createBlock(_component_el_tag, {
                                key: 2,
                                class: "mx-1",
                                type: 
                  item.refundStatus === 'partially_refunded'
                    ? 'warning'
                    : 'danger'
                ,
                                size: "small",
                                title: item.refundReason
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.refundStatus), 1)
                                ]),
                                _: 2
                              }, 1032, ["type", "title"]))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              (item.variantTitle)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_20, [
                                    _hoisted_21,
                                    (item.editVariantTitle)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                                          _createElementVNode("span", null, [
                                            _createVNode(_component_el_select, {
                                              size: "small",
                                              modelValue: item.selectedVariantTitle,
                                              "onUpdate:modelValue": ($event: any) => ((item.selectedVariantTitle) = $event),
                                              filterable: ""
                                            }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item?.product
                              ?.variants ?? [], (variant, index) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: index,
                                                    value: variant.title
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(variant.title), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["value"]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _createVNode(_component_el_link, {
                                            underline: "",
                                            type: "primary",
                                            class: "mx-2",
                                            onClick: ($event: any) => (_ctx.onSaveChangeVariantTitle(item))
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_23
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]),
                                          _createVNode(_component_el_link, {
                                            onClick: ($event: any) => (item.editVariantTitle = false),
                                            underline: "",
                                            type: "primary"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_24
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"])
                                        ]))
                                      : _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_25, [
                                          _createTextVNode(_toDisplayString(item.variantTitle) + " ", 1),
                                          _createVNode(_component_el_link, {
                                            onClick: ($event: any) => (_ctx.onChangeVariantTitle(item)),
                                            underline: "",
                                            type: "primary"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_26
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"])
                                        ], 512)), [
                                          [_directive_loading, item.loadingProduct]
                                        ])
                                  ]))
                                : _createCommentVNode("", true),
                              (item.sku)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_27, [
                                    _hoisted_28,
                                    _createTextVNode(" " + _toDisplayString(item.sku), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("p", null, [
                                _hoisted_29,
                                (item.catalogCode)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(item.catalogCode), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(` (Not have code) `), 1)),
                                (
                        _ctx.state.order.status === _ctx.ORDER_STATUS.UNFULFILLED ||
                        _ctx.state.order.status === _ctx.ORDER_STATUS.HOLD ||
                        _ctx.state.order.status === _ctx.ORDER_STATUS.IN_REVIEW ||
                        _ctx.state.order.status === _ctx.ORDER_STATUS.APPROVED ||
                        _ctx.state.order.status === _ctx.ORDER_STATUS.IN_PRODUCTION ||
                        _ctx.state.order.status === _ctx.ORDER_STATUS.IN_TRANSIT
                      )
                                  ? (_openBlock(), _createBlock(_component_el_link, {
                                      key: 2,
                                      onClick: ($event: any) => (_ctx.onChangeCatalogCode(item)),
                                      title: "Select catalog code",
                                      underline: "",
                                      type: "primary"
                                    }, {
                                      default: _withCtx(() => [
                                        (item.catalogCode)
                                          ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_32, _hoisted_34, 512)), [
                                              [_directive_loading, _ctx.calculatingOrderBasecost]
                                            ])
                                          : (_openBlock(), _createElementBlock("span", _hoisted_35, "Select code"))
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_36, [
                              (item.quantity)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_37, [
                                    _hoisted_38,
                                    _createTextVNode(" " + _toDisplayString(item.quantity), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (item.refundQty)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_39, [
                                    _hoisted_40,
                                    _createTextVNode(" " + _toDisplayString(item.refundQty), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("p", null, [
                                _hoisted_41,
                                _createTextVNode(" " + _toDisplayString(item.designQty), 1)
                              ]),
                              _createVNode(_component_DetailOrderItem, {
                                item: item,
                                userType: "agency"
                              }, null, 8, ["item"])
                            ]),
                            _createElementVNode("div", _hoisted_42, [
                              (item.custom)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_43, [
                                    _hoisted_44,
                                    (item.custom?.map((item) => item?.value)?.[0] != null)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          onClick: ($event: any) => (_ctx.onViewDetailCustom(item.custom)),
                                          class: "text-blue-600",
                                          title: "Click to view detail"
                                        }, _toDisplayString(item.custom?.map((item) => item?.value)?.join('; ')), 9, _hoisted_45))
                                      : (_openBlock(), _createElementBlock("a", {
                                          key: 1,
                                          onClick: ($event: any) => (_ctx.onViewDetailCustom(item.custom)),
                                          class: "text-blue-600",
                                          title: "Click to view detail"
                                        }, " View Detail Custom ", 8, _hoisted_46))
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            (item.customTexts)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                  _hoisted_48,
                                  _createElementVNode("div", _hoisted_49, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.customTexts, (customText, index) => {
                                      return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(customText.display_key) + " : " + _toDisplayString(customText.display_value), 1))
                                    }), 128))
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        (_ctx.isShowFulfillmentPrice)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                              _createElementVNode("p", null, [
                                _createElementVNode("b", null, _toDisplayString(item.quantity - (item.refundQty ?? 0)), 1),
                                _createTextVNode(" x " + _toDisplayString(_ctx.formatterDollars(item.baseCost)) + " = ", 1),
                                _createElementVNode("b", null, _toDisplayString(_ctx.formatterDollars(
                      item.baseCost * (item.quantity - (item.refundQty ?? 0))
                    )), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_el_divider, { direction: "horizontal" })
                      ]),
                      _: 2
                    }, 1024))
                  }), 128)),
                  (_ctx.isShowFulfillmentPrice)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_51, " Total cost: " + _toDisplayString(_ctx.formatterDollars(_ctx.state.order.sellerBaseCost)), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              (_ctx.isShowFulfillmentPrice)
                ? (_openBlock(), _createBlock(_component_OrderFeesCard, {
                    key: 0,
                    class: "my-3",
                    order: _ctx.state.order
                  }, null, 8, ["order"]))
                : _createCommentVNode("", true),
              (_ctx.isShowFulfillmentPrice)
                ? (_openBlock(), _createBlock(_component_OrderProfitCard, {
                    key: 1,
                    class: "my-3",
                    order: _ctx.state.order
                  }, null, 8, ["order"]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_card, { class: "my-3" }, {
                header: _withCtx(() => [
                  _hoisted_52
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Timeline)
                ]),
                _: 1
              }),
              (_ctx.state.order?.changeHistory)
                ? (_openBlock(), _createBlock(_component_el_card, {
                    key: 2,
                    class: "my-3"
                  }, {
                    header: _withCtx(() => [
                      _hoisted_53
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_ChangeHistoryContent, {
                        userType: "agency",
                        data: _ctx.state.order?.changeHistory
                      }, null, 8, ["data"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _createVNode(_component_OrderInfo, {
                state: _ctx.state,
                data: _ctx.data,
                onReset: _ctx.fetchRecord,
                onCheckAddress: _ctx.checkingAddress
              }, null, 8, ["state", "data", "onReset", "onCheckAddress"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512), [
        [_directive_loading, _ctx.data.isLoading]
      ]),
      _createVNode(_component_UpdateTrackingDialog, {
        ref: "updateTrackingDialog",
        items: _ctx.state.order.items,
        onUpdateSuccess: _ctx.fetchRecord
      }, null, 8, ["items", "onUpdateSuccess"]),
      _createVNode(_component_UpdateDeliveryDialog, {
        ref: "updateDeliveryDialog",
        items: _ctx.state.order.items,
        orderStatus: _ctx.state.order.status,
        onUpdateSuccess: _ctx.fetchRecord
      }, null, 8, ["items", "orderStatus", "onUpdateSuccess"]),
      _createVNode(_component_CustomDialog, { ref: "customDialog" }, null, 512),
      _createVNode(_component_ChangeCatalogCodeDialog, {
        ref: "changeCatalogCodeDialog",
        onCallbackChangeVariantCode: _ctx.onAfterChangeVariantCode,
        onRefresh: _ctx.fetchRecord
      }, null, 8, ["onCallbackChangeVariantCode", "onRefresh"])
    ]),
    _: 1
  }, 16))
}